type TSeason = 'spring' | 'summer' | 'fall' | 'winter';

export const getCurrentSeason = (): TSeason => {
  const month = new Date().getMonth() + 1; // getMonth() returns 0-11, so add 1 for 1-12
  if (month >= 3 && month <= 5) return 'spring';
  if (month >= 6 && month <= 8) return 'summer';
  if (month >= 9 && month <= 11) return 'fall';
  return 'winter'; // Covers December (12), January (1), February (2)
};
